import { isEmpty } from 'lodash';

import { getJobIngestDetails } from 'api/jobs';
import { IngestJobDetails } from 'interfaces/job';
import { useQueryWithErrorAndRetrySnackbar } from 'utils/useQueryWithErrorAndRetrySnackbar';

export const jobIngestDetailsQueryKey = 'job-ingest-details';

export const getJobIngestDetailsQueryKey = (jobId: string) => [jobIngestDetailsQueryKey, jobId] as const;

export const useJobIngestDetails = (
  jobId: string,
  options?: Parameters<typeof useQueryWithErrorAndRetrySnackbar<IngestJobDetails>>[2]
) => {
  const enabled = !isEmpty(jobId) && (options?.enabled ?? true);

  return useQueryWithErrorAndRetrySnackbar<IngestJobDetails>(
    getJobIngestDetailsQueryKey(jobId),
    ({ signal }) => getJobIngestDetails(jobId, signal),
    {
      retry: false,
      queriedEntityName: 'ingest job details',
      consoleOnly: true,
      ...options,
      enabled,
    }
  );
};
